import { gql } from '@apollo/client';

/**
 * Query to fetch applications managed by the user and their direct reports
 */
export const ManagerAndDirectReportsAppsQuery = gql`
  query ManagerAndDirectReportsApps(
    $login: String!
    $pagination: PaginationInput
  ) {
    identity {
      user(login: $login) {
        resources {
          applicationPortfolio(pagination: $pagination) {
            applications {
              applicationId
              name
              owner {
                displayName
              }
              status
              updatedAt
            }
            totalCount
          }
        }
      }
    }
  }
`;
